import { useEffect, useRef, ReactNode } from 'react';

interface Props {
  load: () => void;
  hasMore: boolean;
  loader: ReactNode;
  children: ReactNode;
}

const InfiniteScroll = ({ load, hasMore, loader, children }: Props) => {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const loadRef = useRef(load);
  const hasMoreRef = useRef(hasMore);
  loadRef.current = load;
  hasMoreRef.current = hasMore;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMoreRef.current) {
          loadRef.current();
        }
      },
      {
        root: document.getElementById('app-page-content'),
        rootMargin: '0px',
        threshold: 1.0,
      },
    );

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="infinite-scroll-component">
      {children}
      <div ref={sentinelRef}>{hasMore && loader}</div>
    </div>
  );
};

export default InfiniteScroll;
